import { SET_PAYMENT_METHODS } from '../actionTypes'
import { B3PaymentMethod, IPPaymentMethod } from '../../request/apis'

declare interface PaymentAction {
  type: string
  payload: any
}

export const setPaymentMethods = (methods: B3PaymentMethod[] | IPPaymentMethod[]): PaymentAction => ({
  type: SET_PAYMENT_METHODS,
  payload: methods
})